<template>
  <div
    v-if="publication"
    class="w-full max-w-[400px] rounded-2xl border border-[#E9E6F3] bg-white px-4 py-3 text-left"
  >
    <p class="text-[11px] font-semibold uppercase leading-[1.4] tracking-[0.06em] text-primary">
      Новая публикация
    </p>
    <p class="mt-1 break-words text-[15px] font-bold leading-[1.3] text-txmain">
      №{{ publication.id }}<template v-if="publication.label"> · {{ publication.label }}</template>
    </p>
    <p v-if="summary" class="mt-0.5 text-[13px] leading-[1.4] text-txsecondary">{{ summary }}</p>
  </div>
  <div v-else class="max-w-[80%] rounded-xl bg-primary/10 px-3 py-2 text-center text-xs leading-[1.4] text-primary">
    Системное событие
  </div>
</template>

<script setup lang="ts">
  import { getPublicationSummary, getSystemMessagePublication } from "~/common/chatChannels";

  // Событие платформы: content у него пустой, карточку собираем из publicationInfo
  const props = defineProps<{ message: any; chat?: any }>();

  const publication = computed(() => getSystemMessagePublication(props.message, props.chat));
  // Цена, формат, дата и статус в одну строку — как «36 000 ₽ · оплачен» в макете
  const summary = computed(() => {
    if (!publication.value) return "";
    const status = publication.value.status?.text;
    return [getPublicationSummary(publication.value), status && status[0].toLowerCase() + status.slice(1)]
      .filter(Boolean)
      .join(" · ");
  });
</script>
